import { frontendURL } from '../../../helper/URLHelper';
import BlockedContactsConsole from './pages/BlockedContactsConsole.vue';
import LeadsIndex from './pages/LeadsIndex.vue';
import HistoricoCliente from './pages/HistoricoCliente.vue';
import KycRiskReviewQueue from './pages/KycRiskReviewQueue.vue';
import PropertyDemandsConsole from './pages/PropertyDemandsConsole.vue';
import {
  LAIS_CRM_SEND_PERMISSIONS,
  LAIS_LEADS_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/menu-meus-clientes'),
    alias: [
      frontendURL('accounts/:accountId/carteira-clientes'),
      frontendURL('accounts/:accountId/clientes/carteira'),
    ],
    name: 'lais_clients_grouped',
    redirect: laisCanonicalRedirect('lais_leads_index'),
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/pipeline'),
    alias: [
      frontendURL('accounts/:accountId/funil'),
      frontendURL('accounts/:accountId/leads/pipeline'),
      frontendURL('accounts/:accountId/crm/funil'),
    ],
    name: 'lais_leads_pipeline',
    redirect: laisCanonicalRedirect('lais_leads_index', {
      query: { view: 'funil' },
    }),
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/leads/repasses'),
    alias: [
      frontendURL('accounts/:accountId/repasses'),
      frontendURL('accounts/:accountId/lead_referrals'),
    ],
    name: 'lais_lead_referrals',
    redirect: laisCanonicalRedirect('lais_leads_index', {
      query: { view: 'repasses' },
    }),
    meta: { permissions: LAIS_CRM_SEND_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/crm/tasks'),
    alias: [
      frontendURL('accounts/:accountId/crm/tarefas'),
      frontendURL('accounts/:accountId/tarefas-crm'),
      frontendURL('accounts/:accountId/leads/tasks'),
    ],
    name: 'lais_crm_tasks',
    redirect: laisCanonicalRedirect('lais_leads_index', {
      query: { view: 'tarefas' },
    }),
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/crm/demandas'),
    alias: [
      frontendURL('accounts/:accountId/leads/demandas'),
      frontendURL('accounts/:accountId/demandas'),
      frontendURL('accounts/:accountId/property-demands'),
    ],
    name: 'lais_property_demands_console',
    component: PropertyDemandsConsole,
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/crm/contatos-bloqueados'),
    alias: [
      frontendURL('accounts/:accountId/clientes/bloqueados'),
      frontendURL('accounts/:accountId/leads/bloqueados'),
      frontendURL('accounts/:accountId/blocked_contacts'),
    ],
    name: 'lais_blocked_contacts_console',
    component: BlockedContactsConsole,
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/crm/kyc'),
    alias: [
      frontendURL('accounts/:accountId/leads/kyc'),
      frontendURL('accounts/:accountId/kyc/revisao'),
      frontendURL('accounts/:accountId/diligencia/kyc'),
    ],
    name: 'lais_kyc_risk_review_queue',
    component: KycRiskReviewQueue,
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/leads'),
    alias: [
      frontendURL('accounts/:accountId/clientes'),
      frontendURL('accounts/:accountId/history'),
      frontendURL('accounts/:accountId/historico'),
      frontendURL('accounts/:accountId/lead'),
      frontendURL('accounts/:accountId/crm'),
      frontendURL('accounts/:accountId/qualificacao'),
      frontendURL('accounts/:accountId/qualification'),
    ],
    name: 'lais_leads_index',
    component: LeadsIndex,
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/history/:id'),
    alias: [
      frontendURL('accounts/:accountId/historico/:id'),
      frontendURL('accounts/:accountId/leads/:id/historico'),
      frontendURL('accounts/:accountId/leads/:id/history'),
    ],
    name: 'lais_lead_historico',
    component: HistoricoCliente,
    meta: { permissions: LAIS_LEADS_PERMISSIONS },
  },
];
